/**
 * @type {Object}
 */
const triggeredGoogleAnalyticsFields = {};

module.exports = triggeredGoogleAnalyticsFields;